import React, {useEffect, useState} from "react";
import UpdateHistoryShowData from "./ui/showData";
import UpdateHistoryModalEdit from './ui/modalEdit';
import {ThaiDatepicker} from "../../../Components/Datepicker/thai-datepicker";
import useUpdateHistoryData from "./hooks/use-update-history-report-data";
import {useParams} from "react-router";
import Pagination from "@material-ui/lab/Pagination";
import {Spinner} from "react-bootstrap";
import useUpdateHistoryReportData from "./hooks/use-update-history-report-data";
import {useTranslation} from "react-i18next";
import * as Icon from "react-bootstrap-icons";
import { Typeahead } from "react-bootstrap-typeahead";
import { CustomerTypeService} from "../../../Service/service.CashOnDelivery";
import ReactExport from "react-data-export";
import {DimensionValidate, DimensionValidateAll, editHistoryReportExcelNew} from "../../../Service/service.Parcels";
import { useHistory } from "react-router-dom";
import { swalSuccess, swalError } from "../../../Components/sweetAlert";


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const UpdateHistoryReport = () => {
    const history = useHistory();
    var year = new Date().getFullYear();
    var years = Array.from(new Array(3), (e, index) => year - index);
    var month = new Date().getMonth()+1;
    var day = new Date().getDate();
    var dayStr = day<10? '0'+day:day;
    var date = new Date().getDate();
    const [currentPage, setCurrentPage] = useState(1);
    // const [dataExport, setDataExport] = useState([]);
    const {data,dataExport,error,loading,loadingExcel,fetchData,fetchDataExcel} = useUpdateHistoryReportData();
    const params = useParams();
    const [dataExcel,setDataExcel] = useState([]);
    const [search,setSearch] = useState('');
    const [cust_code,setCustCode] = useState('');
    const [startDate,setStartDate] = useState(''+year+"-"+month+"-"+dayStr+" "+"00:00:00");
    const [endDate,setEndDate] = useState(''+year+"-"+month+"-"+dayStr+" "+"23:59:59");
    const [cust, Cust] = useState([]);
    const [customer_type, Customer_type] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dataRow,setDataRow]= useState([]);
    const [length, setLength]=useState(0);
    const [width, setWidth]=useState(0);
    const [height, setHeight]=useState(0);
    const [weight, setWeight]=useState(0);

     
    useEffect(() => {
        if((localStorage.getItem("superkey")!=="admin" 
        && localStorage.getItem("superkey")!=="conveyor")  
        || !localStorage.getItem("superkey")){
          history.push("/notAvailable");
        }
        fetchData(search, localStorage.getItem("superkey")==="credit"?localStorage.getItem("username"):cust_code, startDate, endDate, currentPage);
      }, [currentPage]);

    const handleChangePage = (_evt,newPage) => {
      setCurrentPage(newPage);
    };

    async function CustomerType(data) {
        const result = await CustomerTypeService(data);
        if (data != null) {
            Cust(result.data);
        }
    }

    async function handleSubmit2Excel(){
        fetchDataExcel(search,cust_code,startDate,endDate)
    }

    async function validateDimension(id){
        try {
            let result = await DimensionValidate({id: id, custcode: "LL001"});
            if (result.status === 0) {
                swalError();
            } else {
            // setData([]);
            // setErrorMassNoData([])
                swalSuccess();
                fetchData(search, localStorage.getItem("superkey")==="credit"?localStorage.getItem("username"):cust_code, startDate, endDate, currentPage);
            }
        }
        catch (e) {
            swalError({
            text: t(e.response.data.message),
            });
        }
    
    }

    async function validateDimensionAll(){
        try {
            let result = await DimensionValidateAll({custcode: "LL001"});
            if (result.status === 0) {
                swalError();
            } else {
            // setData([]);
            // setErrorMassNoData([])
                swalSuccess();
                fetchData(search, localStorage.getItem("superkey")==="credit"?localStorage.getItem("username"):cust_code, startDate, endDate, currentPage);
            }
        }
        catch (e) {
            swalError({
            text: t(e.response.data.message),
            });
        }
    
    }

    async function editDimension(data){}

    async function getDataExcel(search,cust_code,start_date,end_date){
        try{
            // setLoadingExcel(true);
            let result = await editHistoryReportExcelNew(search,cust_code,start_date,end_date);
            // alert(JSON.stringify(result))
            setDataExcel(result.data===false?[]:result.data);
        }
        catch (e) {
            console.error(e);
            alert(e)
            // setError('An error occured');
        }
        finally {
            document.getElementById("downloadEx1").click();
            // setLoadingExcel(false);
        }
    }

    const {t} = useTranslation();
    
    return (
        <>
            <center><h1>แก้ไขข้อมูล</h1></center>
            <div style={{ overflow: 'auto', width: '100%' }}>
                <div className=""></div>
                {!loading && data && (
                    <div className="center">
                        <div className="w-100">
                            {/* Top Row: Search + Customer Type + Typeahead */}
                            <div className="row g-2">

                                {/* Customer Type Select */}
                                {localStorage.getItem("superkey")!=="credit"?
                                (<div className="col-12 col-md-6">
                                    <div className="row">
                                    <div className="col-12 col-md-5">
                                        <label className="form-label d-block">ประเภทลูกค้า</label>
                                        <select
                                        value={customer_type}
                                        onChange={(e) => {
                                            Customer_type(e.target.value);
                                            CustomerType({ customer_type: e.target.value });
                                        }}
                                        className="form-control"
                                        >
                                        <option value={""}>ประเภทผู้ใช้</option>
                                        <option value={"4"}>เครดิต</option>
                                        <option value={"3"}>หน้าร้าน</option>
                                        </select>
                                    </div>

                                    {/* Typeahead */}
                                    <div className="col-12 col-md-5">
                                        <label className="form-label">รหัสลูกค้า</label>
                                        <div className="input-group flex-nowrap">
                                        <Typeahead
                                            id="basic-typeahead-single"
                                            onChange={(selected) => {
                                                setCustCode(selected?.[0]?.cust_code ?? '');
                                            }}
                                            options={cust}
                                            labelKey={(option) => `${option.cust_code} ${option.name}`}
                                            placeholder="ชื่อ"
                                            selected={cust_code ? [{ cust_code, name: '' }] : []}
                                        />
                                        </div>
                                    </div>
                                    </div>
                                </div>):(<></>)
                                }

                                {/* Search */}
                                <div className="col-12 col-md-6">
                                    <label className="form-label">ค้นหา</label>
                                    <input
                                    className="form-control"
                                    value={search}
                                    placeholder=""
                                    onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>

                                </div>

                            {/* Second row: Date pickers + Button */}
                            <div className="row g-3 align-items-end mt-1">
                                <div className="col-12 col-lg-4">
                                    <div className="form-group">
                                        <ThaiDatepicker
                                        isTimePicker={true}
                                        label={t('hub.filters.startDate')}
                                        date={startDate}
                                        onChange={(date) => {
                                            setStartDate(new Date(date).toISOString().slice(0, 19).replace("T", " "));
                                        }}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-lg-4">
                                    <div className="form-group">
                                        <ThaiDatepicker
                                        isTimePicker={true}
                                        label={t('hub.filters.endDate')}
                                        date={endDate}
                                        onChange={(date) => {
                                            setEndDate(new Date(date).toISOString().slice(0, 19).replace("T", " "));
                                        }}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-lg-4">
                                    {/* Make button full width on small screens, nicely aligned on large */}
                                    <div className="d-grid">
                                        <button
                                        type="button"
                                        className="btn btn-primary w-100"
                                        onClick={() => {
                                            fetchData(search, localStorage.getItem("superkey")==="credit"?localStorage.getItem("username"):cust_code, startDate, endDate, 1);
                                        }}
                                        >
                                        <Icon.Search /> {t('common.search')}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="row g-3 align-items-center mt-1">
                                <div className="col-12 col-lg-4">
                                    <div className="d-grid">
                                        <span>
                                            <button className="btn btn btn-info" onClick={ async (e)=>{
                                                    // await handleSubmit2Excel();
                                                    await getDataExcel(search,localStorage.getItem("superkey")==="credit"?localStorage.getItem("username"):cust_code,startDate,endDate);
                                                    // alert(JSON.stringify(dataExport));
                                                    // if(!loadingExcel){
                                                    //     // document.getElementById("downloadEx1").click();
                                                    // }
                                
                                                }}><Icon.FileEarmarkArrowUp /> export</button>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="row g-3 align-items-center mt-1">
                                <div className="col-12 col-lg-4">
                                    <div className="d-grid">
                                        <span>
                                            <button className="btn btn btn-success" onClick={ async (e)=>{
                                                    // await handleSubmit2Excel();
                                                    let resDAll = await validateDimensionAll();
                                                    // alert(JSON.stringify(dataExport));
                                                    // if(!loadingExcel){
                                                    //     // document.getElementById("downloadEx1").click();
                                                    // }
                                
                                                }}><Icon.Check2All /> Validate all</button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                        <ExcelFile
                            element={
                                // <button style={{ display: "none" }} id="downloadEx">
                                <button style={{display: "none"}} className="btn btn-primary" id="downloadEx1">
                                Download Data
                                </button>
                            }
                            filename="dimension History"
                            >
                            <ExcelSheet data={dataExcel} name={"COD History"}>
                                <ExcelColumn label="เลขลาเบล" value="awb_code" />
                                <ExcelColumn label="รหัสลูกค้า" value="validator_cust_code" />
                                <ExcelColumn label="ว/ด/ป ที่โอนเงินคืนลูกค้า" value="scan_date" width={{ wpx: 300 }}/>
                                <ExcelColumn label="ผู้แก้ไขข้อมูล" value="staff_code" />
                                <ExcelColumn label="weight" value="weight" />
                                <ExcelColumn label="length" value="length" />
                                <ExcelColumn label="height" value="height" /> 
                                <ExcelColumn label="width" value="width" />
                            </ExcelSheet>
                        </ExcelFile>

                        <UpdateHistoryModalEdit 
                        dataRow={dataRow} 
                        setDataRow={setDataRow} 
                        setLength={setLength} 
                        setHeight={setHeight} 
                        setWidth={setWidth} 
                        setWeight={setWeight} 
                        isModalOpen={isModalOpen} 
                        setIsModalOpen={setIsModalOpen}
                        length={length} 
                        width={width} 
                        height={height} 
                        weight={weight} />

                        <UpdateHistoryShowData 
                            data={data.result} validateDimension={validateDimension} 
                            setIsModalOpen={setIsModalOpen} 
                            setDataRow={setDataRow} 
                            setLength={setLength} 
                            setWidth={setWidth} 
                            setHeight={setHeight} 
                            setWeight={setWeight} 
                            length={length} 
                            width={width} 
                            height={height} 
                            weight={weight} />
                        <Pagination
                            count={data.maxPage}
                            page={currentPage}
                            onChange={handleChangePage}
                            color="primary"
                            size="small"
                            defaultPage={1}
                            siblingCount={1}
                        />
                    </div>
                )}
                {loading && <div className="spinner-global-content">
                    <Spinner variant="success" animation="border" />
                </div> }
            </div>
        </>
    )
}
export default UpdateHistoryReport;